"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVouchers200ResponseToJSON = exports.GetVouchers200ResponseFromJSONTyped = exports.GetVouchers200ResponseFromJSON = exports.instanceOfGetVouchers200Response = void 0;
var runtime_1 = require("../runtime");
var Voucher_1 = require("./Voucher");
/**
 * Check if a given object implements the GetVouchers200Response interface.
 */
function instanceOfGetVouchers200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetVouchers200Response = instanceOfGetVouchers200Response;
function GetVouchers200ResponseFromJSON(json) {
    return GetVouchers200ResponseFromJSONTyped(json, false);
}
exports.GetVouchers200ResponseFromJSON = GetVouchers200ResponseFromJSON;
function GetVouchers200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(Voucher_1.VoucherFromJSON)),
    };
}
exports.GetVouchers200ResponseFromJSONTyped = GetVouchers200ResponseFromJSONTyped;
function GetVouchers200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(Voucher_1.VoucherToJSON)),
    };
}
exports.GetVouchers200ResponseToJSON = GetVouchers200ResponseToJSON;
